export default __webpack_public_path__ + "static/media/jumper2.ebabf9a8.png";